/* Name: tokeninterceptor.jsx
* Copyright: (c) DA-Design Oy
* Creation date: 14.05.2024   (EKn)
*
* Description:
*/

import axios from 'axios';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from '../authConfig';
import { useEffect } from 'react';

const API_SERVER = import.meta.env.VITE_API_SERVER;

export let sm4request = axios.create({
  baseURL: API_SERVER,
  headers: {
    'Content-type': 'application/json'
  }
});

const ID_TOKEN_EXPIRY_MARGIN_SECONDS = 5 * 60;

const hasUsableIdToken = (response) => {
  const exp = response?.idTokenClaims?.exp;
  return Boolean(response?.idToken) &&
    typeof exp === 'number' &&
    exp - ID_TOKEN_EXPIRY_MARGIN_SECONDS > Math.floor(Date.now() / 1000);
};

export const TokenInterceptorProvider = () => {
  const { accounts, instance } = useMsal();
  const account = instance.getActiveAccount() || accounts[0];
 
  useEffect(() => {
    if(!account) return;
    const interceptorId = sm4request.interceptors.request.use(async (config) => {
      let response = await instance.acquireTokenSilent({
        ...loginRequest,
        account,
      });

      if (!hasUsableIdToken(response)) {
        response = await instance.acquireTokenSilent({
          ...loginRequest,
          account,
          forceRefresh: true,
        });
      }

      if (!hasUsableIdToken(response)) {
        return Promise.reject(new Error('Microsoft Entra did not return a valid ID token.'));
      }

      config.headers.Authorization = `Bearer ${response.idToken}`;
      return config;
    });

    return () => sm4request.interceptors.request.eject(interceptorId);
  }, [account, instance]);
 
  return null;
};
